import { Button, Grid, Typography } from "@mui/material";
import { Pause, PlayArrow, PowerSettingsNew } from "@mui/icons-material";
import { red, green } from "@mui/material/colors";
import HeaderTable from "./headerTable";
import { useWebSocketConnection } from "../../services/connectionContext/connectionContext";
import { useEffect, useState } from "react";

export const RawDataAndRadarInterface = ({ title, socketUrl }) => {
    const { eventEmitter, webSocketSend, webSocketSwitchGetData } = useWebSocketConnection();
    const socketGetDataEvent = 'ON_MESSAGE' + socketUrl + 'getData';
    const socketStatusEvent = 'ON_MESSAGE' + socketUrl + 'status';
    const socketTargetsEvent = 'ON_MESSAGE' + socketUrl + 'targets';
    const [getData, setGetData] = useState(true);
    const [status, setStatus] = useState({
        downloads: [],
        activate: false,
        process_status: { min_dist: 0, max_dist: 1, frequency_hz: 0 },
        radar_recorder: { description: '', postfix: '', started: true },
    });
    const [targets, setTargets] = useState({ targets: [0, 0, 0], header: { timestamp_read: 0 } });

    useEffect(() => {
        eventEmitter.on(socketGetDataEvent, setGetData);
        eventEmitter.on(socketStatusEvent, setStatus);
        eventEmitter.on(socketTargetsEvent, setTargets);
        return () => {
            eventEmitter.off(socketGetDataEvent, setGetData);
            eventEmitter.off(socketStatusEvent, setStatus);
            eventEmitter.off(socketTargetsEvent, setTargets);
        }
    }, [eventEmitter, socketGetDataEvent, setGetData, socketStatusEvent, setStatus, socketTargetsEvent, setTargets]);

    return (
        <>
            <Grid item xs={6} sm={6}>
                <Typography variant='h6'>
                    {title}
                </Typography>
                <Button
                    endIcon={getData ?
                        <Pause style={{ color: red[300] }} />
                        : <PlayArrow style={{ color: green[300] }} />}
                    style={{ width: "40%", float: "left" }}
                    variant="outlined"
                    onClick={() => {
                        webSocketSend({ socketUrl: socketUrl, data: { type: "radar:raw" } })
                        webSocketSwitchGetData({ socketUrl: socketUrl, data: { type: "GETDATA" } }); //TODO: Prüfen ob diese Funktionalität bereits besteht!
                    }}>
                    {getData ? "Pause raw data" : "Start raw data"}
                </Button>

                {/* <Button
                    style={{ width: "40%", float: "left" }}
                    variant="outlined"
                    onClick={() => {
                        console.log(getData);
                        console.log(status);
                        console.log(targets);
                    }}>
                    HarryPotter
                </Button> */}

                {status.activate ?
                    <Button
                        style={{ float: 'right', width: "40%" }}
                        startIcon={<PowerSettingsNew style={{ color: red[300] }} />}
                        onClick={() => webSocketSend({ socketUrl: socketUrl, data: { type: "radar:deactivate", payload: "" } })}
                        variant="outlined" >Deactivate Radar</Button>
                    : <Button
                        style={{ float: 'right', width: "40%" }}
                        startIcon={<PowerSettingsNew style={{ color: green[300] }} />}
                        variant="outlined"
                        onClick={() => webSocketSend({ socketUrl: socketUrl, data: { type: "radar:activate", payload: "" } })}>
                        Activate Radar
                    </Button>
                }
                <br></br>
                <HeaderTable header={targets?.header} />
            </Grid>
        </>
    )
}

export default RawDataAndRadarInterface;